exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form-in-place-restore .description-block {\n  padding-bottom: 20px; }\n\n.form-in-place-restore .form-block {\n  margin-top: 0px; }\n\n.form-in-place-restore .form-action {\n  float: right; }\n\n.form-in-place-restore .restore-vm-container {\n  background-color: #eaeef0;\n  margin-bottom: 15px;\n  padding: 10px 0 0 15px; }\n\n.form-in-place-restore form {\n  padding-top: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vcd/in-place-restore/in-place-restore.scss
// module id = EP6x
// module chunks = 0